export const SECTIONS_LIBRARY_MODAL_CATEGORIES = {
  HERO: 'HERO',
  CALL_TO_ACTION: 'CALL_TO_ACTION',
  PRODUCTS_AND_SERVICES: 'PRODUCTS_AND_SERVICES',
  EVENTS: 'EVENTS',
  TEAM: 'TEAM',
  SOCIAL_PROOF: 'SOCIAL_PROOF',
  PRICING: 'PRICING',
  FORMS: 'FORMS',
  MEDIA: 'MEDIA',
  FAQS: 'FAQS',
  SAVED_SECTIONS: 'SAVED_SECTIONS',
  BLANK_LAYOUTS: 'BLANK_LAYOUTS',
  ALL: 'ALL'
};
export const SECTIONS_LIBRARY_ACTION = 'Sections Library Action';